export default __webpack_public_path__ + "static/media/featureTab.64775957.svg";